var $ = require('./jCube');
var Control = require('./renderer/control');
var Dom = require('./renderer/dom');
var defaultElements = require('./renderer/controls');

var options = {
    log: true,

    form_container_id: '',
    form_container_class: ''
};

var FormRenderer = /** @class */ function ( target, data ) {

    this.data = {};

    var processData = function (instance) {

        return instance.data.map(function (item) {
            var _control = 'control' + $.camelCase(item.type, true);

            item.controlName = _control;

            if (typeof defaultElements[_control] === 'undefined') {
                console.error("Invalid control type. [" + _control + "]");
                return null;
            }

            var _pre = Control.preBuild(item);
            return defaultElements[_control].build(_pre);
        })
    };

    if ( !target || !data) {
        throw new Error("Error FormRenderer: Invalid arguments.");
    }

    if (typeof data === 'string' || data instanceof String) {
        this.data = JSON.parse(data);

    } else if (data.constructor === Array) {
        this.data = data;

    } else {
        throw new Error("Error FormRenderer: Invalid data argument.");
    }

    var _dom = Dom.render({
        tagName: 'div',
        frame: false,
        id: options.form_container_id,
        className: options.form_container_class,
        children: processData(this)
    });

    target.append(_dom);

    return target;
};

module.exports = FormRenderer;
